import { Component } from '@angular/core';
declare var $: any;
import { Agent, EventData, ISupervisorInit } from './interfaces/agent.interface';
import { AppConfig } from './services/app.config.services';
import { TrsEventsService } from './services/trsevents.service';
import { ToastrService } from 'ngx-toastr';
import { NavigationStart, Router } from '@angular/router';
import { IdleService, IdleWarningStates } from 'ngx-idle-timeout';
import { wsService } from './services/ws.service';
import { IMilestoneSummaryInfo } from './interfaces/Logs.interface';
import { getFormattedDateTime, getUTCDateObj } from './utils/timeManager';
import { log } from './utils/logging';
import { LogUpload } from './utils/log-upload';
import { AuditService } from './services/audit.service';
import { getItemValueFromCookie } from './utils/cookie';
import { checkIfBroadcastChannelIsOpen, closeBroadcastChannel, isExistingLoginAvailable } from './utils/login';
import { AgentListInfo } from './services/agent.list.info';
import { setNotificationSound } from './utils/sound';
import { Subscription } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';
import { filter } from 'rxjs/operators';
import { FaceLoginService } from './services/face-login.service';
import { generateMessage } from './utils/messages';
import { IAgentSessionListRequestPayload, IArchiveRequestPayload, IDisagreeViolationRequestPayload, IGenericRequestPayload, ILoadViolationRequestPayload, InsertViolationToDbRequestPayload, InsertViolationToDbRequestPayload2, IPinRequestPayload, IRefreshMediaRequestPayload, IScreenGrabRequestPayload, IStealthModeResponsePayload, ISupervisorInitRequestPayload, ISupervisorPreferencePayload, ISupervisorPreferenceRequestPayload, ISWFHMessagePayload, ITeamCheckInRequestPayload, IUnblockScreenRequestPayload, IUniqueViolationsRequestPayload, IViolationWorkflowRequestPayload, IWebRTCHeartbeatPayload, IWebRTCMessageRequestPayload } from './interfaces/messages';
import { CloseCameraStream, GetCameraDeviceInfo, SetCameraStreamInfo, TriggerStreamForPermission } from './utils/camera';
import { WebRTCService } from './services/webrtc.service';
import { TeamCheckInService } from './services/team.checkin.service';
import { EventFilterService } from './services/event-filter.service';
import { v4 } from 'uuid';
import { SupervisorService } from './services/supervisor.service';

const semverGt = require('semver/functions/gt');
const semverGte = require('semver/functions/gte')
const packageInfo = require('../../package.json');
declare var errorObj: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})

export class AppComponent {
  showPopUp: Boolean = false;
  hideLoading = true;
  showHeaderFooter = false;
  timeleft = 0;
  message = "";
  sessionTakeOverIntervalId = 0;
  sessionOverideTime = 15; //sec
  isLogoutTimerRunning = false;
  sessionOvertakeTimer: NodeJS.Timeout;
  appConfig = AppConfig;
  showLoginPopUp: boolean = false;
  out = false;
  showSignInError: boolean;
  logUploader: LogUpload = new LogUpload("AppComponent");

  progressText = "Checking Environment ...";

  idleTimer = false;
  idleTimerStateSub: Subscription | null;
  idleTimerStoppedSub: Subscription | null;
  subscription: Subscription;

  TRSServerConnected: boolean;
  isServerCompatibleWithUI: boolean;
  isUICompatibleWithServer: boolean;
  networkSpeedChecked: boolean;
  cameraAccessChecked: boolean;
  webSocketSupportChecked: boolean;

  summaryData: IMilestoneSummaryInfo = {
    SummaryId: '',
    CreatedDateTime: getUTCDateObj(),
    Source: packageInfo.displayName,
    SourceVersion: packageInfo.version,
    Mode: 'NA',
    UserName: 'NA',
    IsVDI: false,
    OS: '',
    OpenCLVersion: 'NA',
    RAM: 'NA',
    CPU: 'NA',
    GPU: 'NA',
    Storage: 'NA',
    NetworkAdapters: 'NA',
    Camera: '',
    OtherInfo: 'NA',
  };
  checksDone: boolean = false;
  WSConnected: boolean = true;
  serverConnectionTxt: string = "Connecting to Server";
  showConnectionModal: boolean = true;
  noInternetCount = 0;
  queryParams: {};

  networkOfflineStartTime: number = 0;
  networkOfflineInterval: NodeJS.Timeout;
  maxTimeToWaitAfterNetworkDisconnect: number = 20; //in seconds
  timeIntervalToCheckNetworkDisconnect: number = 2; //in seconds
  browserRefresh: boolean;
  duplicatePage: boolean = false;

  prerequisiteCheckLabel: string = "";
  webSocketSupportLabel: string = ""
  serverCompatLabel: string = "";
  uiCompatLabel: string = "";
  networkSpeedCheckLabel: string = "";
  serverConnectivityLabel: string = "";
  cameraAccessCheckLabel: string = "";
  progressTextCompleteLabel: string = "";
  progressTextRedirectLabel: string = "";
  progressTextPrerequisiteNotMetLabel: string = "";
  pleaseWaitLabel: string = "";
  serverConnectionConnectingLabel: string = "";
  serverConnectionFailedLabel: string = "";
  userLoggedInLabel: string = "";
  websocketNotSupportedLabel: string = "";
  cameraErrorLabel: string = "";
  licenseExpiryErrorLabel: string = "";
  reviewEscalatedViolationLabel: string = "";
  sentEscalatedViolationLabel: string = "";
  escalatedViolationApprovedLabel: string = "";
  escalatedViolationRejectedLabel: string = "";
  violationDisagreedLabel: string = "";
  sessionTakeOverAllowedLabel: string = "";
  sessionTakeOverNotAllowedLabel: string = "";
  sessionTakeoverLabel: string = "";
  sessionOvertakenLabel: string = "";
  loginFailedErrorLabel: string = "";
  iamSessionExpiredLabel: string = "";
  supervisorValidationMessage1: string = "";
  supervisorValidationMessage2: string = "";

  constructor(private trsService: TrsEventsService, private toastService: ToastrService,
    public router: Router, private _idleService: IdleService, private _faceLoginService: FaceLoginService,
    private ws: wsService, private auditService: AuditService, private agentListInfoService: AgentListInfo, private translationService: TranslocoService,
    private webrtcInfoService: WebRTCService, private teamCheckInService: TeamCheckInService, private eventFilterService: EventFilterService,
    private supervisorService: SupervisorService) {

    const configuredLanguage: string = this.appConfig.settings.defaults.Language;

    if (configuredLanguage != null && configuredLanguage !== "") {
      if (this.translationService.isLang(configuredLanguage) === true) {
        log.info(`${configuredLanguage} language is available, setting as default.`);
        this.translationService.setActiveLang(configuredLanguage);
      }
      else {
        log.warn(`${configuredLanguage} language is not available, setting en as default.`);
        this.translationService.setActiveLang('en');
      }
    }
    else {
      log.error(`language is not configured, setting en as default.`);
      this.translationService.setActiveLang('en');
    }

    this.translationService.load(this.translationService.getActiveLang()).subscribe();

    this.translationService.events$.pipe(filter(event => event.type === 'translationLoadSuccess')).subscribe(() => {
      this.sendEvent("UPDATE_APP_LABELS", {});

      this.prerequisiteCheckLabel = this.translationService.translate("Prerequisite Check");
      this.webSocketSupportLabel = this.translationService.translate("Web Socket Support");
      this.serverCompatLabel = this.translationService.translate("Server compatibility with UI");
      this.uiCompatLabel = this.translationService.translate("UI compatibility with Server");
      this.networkSpeedCheckLabel = this.translationService.translate("Network Speed Check");
      this.serverConnectivityLabel = this.translationService.translate("Server Connectivity");
      this.cameraAccessCheckLabel = this.translationService.translate("Camera Access Check");
      this.progressTextCompleteLabel = this.translationService.translate("Complete");
      this.progressTextRedirectLabel = this.translationService.translate("Redirecting to Authentication!");
      this.progressTextPrerequisiteNotMetLabel = this.translationService.translate("Prerequisites not met!");
      this.pleaseWaitLabel = this.translationService.translate("Please Wait");
      this.serverConnectionFailedLabel = this.translationService.translate("Failed to connect to server!");
      this.serverConnectionTxt = this.serverConnectionConnectingLabel = this.translationService.translate("Connecting to Server");
      this.userLoggedInLabel = this.translationService.translate("User already logged in");
      this.websocketNotSupportedLabel = this.translationService.translate("Websocket Not Supported");
      this.cameraErrorLabel = this.translationService.translate("Please close any other application(s) using the camera and try again");
      this.licenseExpiryErrorLabel = this.translationService.translate("Maximum usage slot reached, Contact your administrator!");
      this.reviewEscalatedViolationLabel = this.translationService.translate("Escalated violation is available to be reviewed");
      this.sentEscalatedViolationLabel = this.translationService.translate("Violation sent for review");
      this.escalatedViolationApprovedLabel = this.translationService.translate("A violation sent earlier for review has been approved by the superadmin");
      this.escalatedViolationRejectedLabel = this.translationService.translate("A violation sent earlier for review has been rejected by the superadmin");
      this.violationDisagreedLabel = this.translationService.translate("Agree/Disagree comments updated successfully!");
      this.sessionTakeOverAllowedLabel = this.translationService.translate("Another user is logged in with the same lanid. Please try to login again after");
      this.sessionTakeOverNotAllowedLabel = this.translationService.translate("You are not allowed to login, as another user is logged in with same lanid");
      this.sessionTakeoverLabel = this.translationService.translate("Session Takeover");
      this.sessionOvertakenLabel = this.translationService.translate("Another user logged in with Same lanid. Your session will end in");
      this.loginFailedErrorLabel = this.translationService.translate("User Id invalid or not authorized to login with");
      this.iamSessionExpiredLabel = this.translationService.translate("Session (IAM) has expired, please login again.");
      this.supervisorValidationMessage1 = this.translationService.translate("Supervisor feature is not enabled");
      this.supervisorValidationMessage2 = this.translationService.translate("Supervisor does not have any features");
    });

    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.browserRefresh = !router.navigated;
      }
    });

  }

  async ngOnInit(): Promise<void> {
    try {
      log.debug(`AppComponent - ngOnInit`);
      if (errorObj) {
        this.router.navigate(["error"]);
        this.checksDone = true;
        this.progressText = this.progressTextCompleteLabel;
        return;
      }
      const params: URLSearchParams = new URLSearchParams(window.location.href.split('?')[1]);

      const token: string | null = params.get('token') || params.get('Token');
      const traceId: string | null = params.get('traceId') || params.get('TraceId');

      //If there is a token present in the url (currently only sent by IAM) then do the below
      if (window.location.href.split('?')[1] != null && token != null && token != "") {
        // this.ws.traceId = (traceId == null || traceId == "") ? uuid() : traceId;
        // this.trsService.traceId = this.ws.traceId;
        this.generateTraceId(traceId || '');
        log.info(`Received token: ${token} and traceId: ${traceId}`);

        if (token != null && token != "") {
          //Token comes in the case of IAM login
          this.getSupervisorIdFromToken(token);
        }

        this.subscribeToEvents();
      }
      else {
        this.generateTraceId(traceId || '');

        if (this.trsService.supervisorId == null || this.trsService.supervisorId === "") {
          const supervisorIdBeforePageReload: string | null = this.ws.getSupervisorId();
          if (supervisorIdBeforePageReload != null && supervisorIdBeforePageReload !== "") {
            if (this.appConfig.settings.defaults.FaceLoginEnabled === true)
              this._faceLoginService.isFaceAuthSuccess = true;
            this.trsService.supervisorId = supervisorIdBeforePageReload;
          }
        }

        this.summaryData.SummaryId = this.ws.traceId;
        this.summaryData.CreatedDateTime = getUTCDateObj();

        log.info(`ngOnInit - TraceId: ${this.ws.traceId}`);
        this.logUploader.info("ngOnInit", this.ws.traceId + " Application Logged");
        if (this.trsService.supervisorId == null || this.trsService.supervisorId === "") {
          if (traceId == null || traceId == "")
            await this.prerequisiteCheck();
          else {
            //If traceId is present in url that means the page was launched previously, login was done via external provider (SSO) and it was redirected back here
            this.checksDone = true;
            this.progressText = this.progressTextCompleteLabel;
          }
        }

        if (this.appConfig.settings.SSO.Enabled === true) {
          log.info(`SSO Login is enabled`);
          this.logUploader.warn("ngOnInit", this.ws.traceId + "SSO Login enabled");

          var isConcurrent = params.get('IsConcurrent');
          if (isConcurrent) {
            this.logUploader.warn("ngOnInit", this.ws.traceId + "User already logged in");
            this.toastService.warning(this.userLoggedInLabel);
            this.showSignInError = true;
            return;
          } else if (traceId != null && traceId != "") {
            setTimeout(() => this.sendEvent("PERFORM_SSO_LOGIN", {}), 500);
          }
        }
        else if (this.appConfig.settings.IAM.Enabled == true) {
          log.info(`IAM Login is enabled`);
          this.logUploader.warn("ngOnInit", this.ws.traceId + "IAM Login enabled");
        }
        else {
          log.info(`Default Login is enabled`);
          this.logUploader.warn("ngOnInit", this.ws.traceId + "Default Login enabled");

          if (traceId == null || traceId == "") {
            //Indicates this is default login
            //Have to use setTimeout because ngOnInit of loginComponent will not be loaded, which means the evtDataObservable.subscribe would not have been triggered
            setTimeout(() => {
              this.sendEvent("PREREQUISITE_COMPLETE", {});
            }, 500);
          }
        }
        this.doOnload();
        this.ws.connect();
        this.subscribeToEvents();
      }
    }
    catch (error) {
      log.error(`AppComponent ngOnInit Error`, error);
      this.logUploader.error("ngOnInit error", this.ws.traceId, error);
    }
  }

  generateTraceId = (traceId: string): void => {
    let newTraceId;
    if (window.name) {
      newTraceId = window.localStorage.getItem("TraceId") || '';
    }
    else {
      newTraceId = v4();
      window.localStorage.setItem("TraceId", newTraceId);
    }
    this.ws.traceId = (traceId == null || traceId == "") ? newTraceId : traceId;
    this.trsService.traceId = this.ws.traceId;
  }

  subscribeToEvents = (): void => {
    this.trsService.evtDataObservable.subscribe((response: EventData) => {
      switch (response.eventName) {
        case "REFRESH": this.refresh(); break;
        case "loadNextViolationsData": this.loadNextViolations(response.data); break;
        case "SENDFORAPPROVAL": this.sendForApproval(response.data); break;
        case "SendChatMessage": this.sendChatMessage(response.data); break;
        case "CustomBlockScreen": this.blockAgentScreen(response.data.AgentLanId); break;
        case "CustomUnBlockScreen": this.unblockAgentScreen(response.data.AgentLanId); break;
        case "CUSTOM_PEEP_EVENT": this.peepRequest(response.data.AgentLanId); break;
        case "CUSTOM_SCREENGRAB_EVENT": this.screenGrabRequest(response.data.AgentLanId); break;
        case "CUSTOM_STEALTHMODE_ACTION": this.updateStealthModeToServer(response.data); break;
        case "CUSTOM_ARCHIVE_AGENT": this.updateArchiveStatusToServer(response.data); break;
        case "CUSTOM_PIN_AGENT": this.updatePinStatusToServer(response.data); break;
        case "HIDE_HEADER":
          this.serverConnectionTxt = this.serverConnectionFailedLabel;
          break;
        case "LOGOUT_SUPERVISOR": this.handleLogout(response.data.reloadPage, response.data.navigationURL, response.data.redirectToInternalLogoutPage); break;
        case "CUSTOM_DISAGREEVIOLATION": this.sendDisagreeRequestToServer(response.data); break;
        case "LOGUPLOAD": this.clientLogUpload(response.data); break;
        case "SUPERADMIN_APPROVAL": this.handleSuperAdminApproval(response.data); break;
        case "REFRESHMEDIAURL_REQUEST": this.refreshMediaURLRequest(response.data); break;
        case "REFRESHPROFILEPICTURE_REQUEST": this.refreshProfilePicture(response.data); break;
        case "WEBSOCKET_OPENED":
          this.WSConnected = true;
          this.TRSServerConnected = true;

          this.checkOfflineConnection();
          clearInterval(this.networkOfflineInterval);

          if (this.trsService.supervisorId) {
            this.progressText = this.progressTextCompleteLabel;
            this.checksDone = true;
          }
          else this.checkPrerequisites();
          break;
        case "WEBSOCKET_CLOSED":
          this.WSConnected = false;

          if (this.trsService.isLoggedIn === true && this.networkOfflineStartTime === 0 && this.ws.was_close_requested === false) {
            this.networkOfflineStartTime = performance.now();
            //once socket is down, set an interval to check if socket is down every few seconds
            this.networkOfflineInterval = setInterval(this.checkOfflineConnection, this.timeIntervalToCheckNetworkDisconnect * 1000);
          }

          break;
        case "SEND_SCREENGLANCE_MESSAGE": this.sendScreenGlanceMessage(response.data); break;
        case "SEND_SCREENGLANCE_HEARTBEAT": this.sendScreenGlanceHeartBeat(response.data); break;
        case "REDIRECT_RESPONSE": this.handleResponseMessages(response.data); break;
        case "TEAMCHECKIN_REQUEST": this.sendTeamCheckInRequest(response.data); break;
        case "UNIQUE_VIOLATIONS_REQUEST": this.sendUniqueViolationsRequest(); break;
      }
    });
  }

  getSupervisorIdFromToken = async (token: any) => {
    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("access-token-swfh_supervisor", token);

    try {
      const that = this;
      $.ajax({
        url: `${this.appConfig.settings.IAM.API_URL}/api/v1/access-token/validate/swfh_supervisor`,
        type: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-token-swfh_supervisor": token,
        },
        xhrFields: {
          withCredentials: true,
        },
        success: (response: any, status: any, xhr: JQueryXHR) => {
          if (response.isSuccess) {
            if (response.result.userName == null || response.result.userName === "") {
              that.progressText = "Invalid LanId received from IAM";
            }
            else {
              const newToken: string | null = getItemValueFromCookie("access-token-swfh_supervisor");
              const secureSession: string | null = getItemValueFromCookie("__secureSession");

              if (newToken == null || newToken === "") {
                that.progressText = "Invalid LanId received from IAM Server";
              }
              else if (secureSession == null || secureSession === "") {
                that.progressText = "Invalid API Key received from IAM UI";
              }
              else {
                that.progressText = "Complete";
                that.checksDone = true;
                that.trsService.supervisorId = response.result.userName.toUpperCase();
                that.trsService.iamToken = newToken;
                that.trsService.iamUIAPISession = secureSession;
                let data =
                {
                  supervisorId: that.trsService.supervisorId,
                  traceId: that.ws.getTraceId(),
                };
                window.name = JSON.stringify(data);
                window.localStorage.setItem("AgentLanId", response.result.userName);

                that.doOnload();
                that.ws.connect();
                that.setIAMTokenInterval();
              }
            }
          }
        },
        error: function (xhr: JQueryXHR, status: any, err: any) {
          log.error(`Status of getting supervisor id from token`, null, `Status Code: ${xhr.status},\n${xhr.responseText == null ? status : xhr.responseText}`);
          that.logUploader.error("getSupervisorIdFromToken", `Status Code: ${xhr.status},\n${xhr.responseText == null ? status : xhr.responseText}`, null);
        },
      });
    } catch (error) {
      log.error(`Status of getting supervisor id from token`, error);
      this.logUploader.error("getSupervisorIdFromToken", `Status of getting supervisor id from token`, error)
    }
  }

  prerequisiteCheck = async (): Promise<void> => {
    const startTime: number = performance.now();
    this.checkWebSocketSupport();
    this.checkTRSServerWebSocketConnection();
    await this.checkServerCompatibilityWithUI(); //Server is compatible with which ui versions
    await this.checkUICompatibilityWithServer(); //UI requires min which version of server to run
    await this.checkNetworkSpeed();
    if (this.appConfig.settings.defaults.FaceLoginEnabled)
      await this.checkCameraAccess();
    else this.cameraAccessChecked = true;

    this.trsService.UploadMilestoneSummary({
      Info: this.summaryData,
      ConfidentialInfo:
      {
        SummaryId: this.ws.traceId,
        IPAddress: "NA",
        MACAddress: "NA"
      }
    });

    const endTime: number = performance.now();
    log.debug(`Prerequisite Time Taken: ${endTime - startTime} ms`);
    this.logUploader.info("prerequisiteCheck()", `Prerequisite Time Taken: ${endTime - startTime}`);
  }

  checkPrerequisites = (): void => {
    if (this.progressText == "Complete") {
      this.message = "";
      return;
    }

    if (this.webSocketSupportChecked === true && this.TRSServerConnected === true && this.isServerCompatibleWithUI === true &&
      this.networkSpeedChecked === true && this.cameraAccessChecked === true && this.isUICompatibleWithServer === true) {
      setTimeout(() => { this.checksDone = true }, 3000);
      this.progressText = this.progressTextRedirectLabel;
      this.message = "";

      if (this.appConfig.settings.SSO.Enabled === true) {
        //If the user is already logged in
        if (document.cookie.includes("identity") === true) {
          this.checksDone = true;
          this.progressText = this.progressTextCompleteLabel;
        }

        setTimeout(() => this.sendEvent("PERFORM_SSO_LOGIN", {}), 500);
      }
      else if (this.appConfig.settings.IAM.Enabled == true) {
        setTimeout(() => {
          const url: string = `${this.appConfig.settings.IAM.ServerURL}/login?ApplicationIdentity=swfh_supervisor&TraceId=${this.ws.traceId}`;
          log.info(`Navigating to IAM URL: ${url}`);
          window.location.href = url;
        }, 10000);
      }
      else {
        this.sendEvent("PREREQUISITE_COMPLETE", {});
        log.info(`Prerequisite checks have passed`);
      }
    }
    else this.progressText = this.progressTextPrerequisiteNotMetLabel;
  }

  showErrorLabel = (): boolean => {
    return this.showHeaderFooter === true &&
      ((this.webSocketSupportChecked === true && this.TRSServerConnected === true && this.isServerCompatibleWithUI === true &&
        this.networkSpeedChecked === true && this.cameraAccessChecked === true && this.isUICompatibleWithServer === true) ||
        this.isLogoutTimerRunning === true);
  }

  checkWebSocketSupport = (): void => {
    const isSupported: boolean = 'WebSocket' in window || 'MozWebSocket' in window;
    if (isSupported === false) {
      this.webSocketSupportChecked = false;
      this.toastService.warning(this.websocketNotSupportedLabel);
      this.message = "SWFH Supervisor UI not compatible as your browser does not support Websocket. Try a modern browser!";
    }
    else {
      this.webSocketSupportChecked = true;
      log.info(`1. Websocket Supported`)
      this.logUploader.info("checkWebSocketSupport", "1. Websocket Supported");
    }
  }

  private checkTRSServerWebSocketConnection = (): void => {
    const socket: WebSocket = new WebSocket(this.appConfig.settings.defaults.TRSServerURL);
    socket.addEventListener('open', (event: Event) => {
      this.TRSServerConnected = true;
      socket.close();
    });
    socket.addEventListener('error', (event: Event) => {
      this.TRSServerConnected = false;
    });
  }

  checkServerCompatibilityWithUI = async (): Promise<void> => {
    const response: any | null = await this.appConfig.getMinimumRequirementsConfig();

    if (response != null && response !== "") {
      const trsSupervisorVersion: string = packageInfo.version; //Only v4 and above is supported (semantic versioning)
      const minSupportedVersion: string = response.trsSupervisorVersionSupport.min;
      const maxSupportedVersion: string = response.trsSupervisorVersionSupport.max;

      if ((minSupportedVersion === "" || minSupportedVersion === "*") && (maxSupportedVersion === "" || maxSupportedVersion === "*"))
        //This means server supports any ui version
        this.setServerCompatibilityWithUIStatus(true, "", "SWFH Server is compatible with SWFH Supervisor UI!")
      else if (maxSupportedVersion === "" || maxSupportedVersion === "*") {
        //This means server supports any version above the min version

        const firstLetterFromMinVersion: string = Array.from(minSupportedVersion)[0];
        const firstDigitFromMinVersion: number = Number(firstLetterFromMinVersion);

        if (firstDigitFromMinVersion <= 3)
          //This means server supports ui from old legacy versioning, and supervisor ui is v4 and above with semantic versioning so directly approve
          this.setServerCompatibilityWithUIStatus(true, "", "SWFH Server is compatible with SWFH Supervisor UI!")
        else {
          const isCurrentVersionGTEMinVersion: boolean = semverGte(trsSupervisorVersion, minSupportedVersion);

          if (isCurrentVersionGTEMinVersion === true)
            //This means UI is greater than min supported version so directly approve
            this.setServerCompatibilityWithUIStatus(true, "", "SWFH Server is compatible with SWFH Supervisor UI!")
          else
            //This means UI is less than min supported version so directly reject
            this.setServerCompatibilityWithUIStatus(false, "SWFH Server is not compatible with SWFH Supervisor UI!", `4. SWFH Server is not compatible with SWFH Supervisor UI!`);
        }
      }
      else if (minSupportedVersion === "" || minSupportedVersion === "*") {
        //This means server supports any version below the max version

        const firstLetterFromMaxVersion: string = Array.from(maxSupportedVersion)[0];
        const firstDigitFromMaxVersion: number = Number(firstLetterFromMaxVersion);

        if (firstDigitFromMaxVersion <= 3)
          //This means UI is more than max supported version so directly reject
          this.setServerCompatibilityWithUIStatus(false, "SWFH Server is not compatible with SWFH Supervisor UI!", `4. SWFH Server is not compatible with SWFH Supervisor UI!`);
        else {
          const isCurrentVersionGTMaxVersion: boolean = semverGt(trsSupervisorVersion, maxSupportedVersion);

          if (isCurrentVersionGTMaxVersion === true)
            //This means UI is greater than min supported version so directly reject
            this.setServerCompatibilityWithUIStatus(false, "SWFH Server is not compatible with SWFH Supervisor UI!", `4. SWFH Server is not compatible with SWFH Supervisor UI!`);
          else this.setServerCompatibilityWithUIStatus(true, "", "SWFH Server is compatible with SWFH Supervisor UI!");
        }
      }
      else {
        const firstLetterFromMinVersion: string = Array.from(minSupportedVersion)[0];
        const firstDigitFromMinVersion: number = Number(firstLetterFromMinVersion);
        const firstLetterFromMaxVersion: string = Array.from(maxSupportedVersion)[0];
        const firstDigitFromMaxVersion: number = Number(firstLetterFromMaxVersion);
        let isMinRequirementSatisfied: boolean = false;
        let isMaxRequirementSatisfied: boolean = false;

        if (firstDigitFromMinVersion <= 3)
          isMinRequirementSatisfied = true;
        else {
          const isCurrentVersionGTEMinVersion: boolean = semverGte(trsSupervisorVersion, minSupportedVersion);

          isMinRequirementSatisfied = isCurrentVersionGTEMinVersion === true ? true : false;
        }

        if (firstDigitFromMaxVersion <= 3)
          isMaxRequirementSatisfied = false;
        else {
          const isCurrentVersionGTMaxVersion: boolean = semverGt(trsSupervisorVersion, maxSupportedVersion);

          isMaxRequirementSatisfied = isCurrentVersionGTMaxVersion === true ? false : true;
        }

        if (isMinRequirementSatisfied === true && isMaxRequirementSatisfied === true)
          this.setServerCompatibilityWithUIStatus(true, "", `SWFH Server is compatible with SWFH Supervisor UI!`);
        else this.setServerCompatibilityWithUIStatus(false, "SWFH Server is not compatible with SWFH Supervisor UI!", `4. SWFH Server is not compatible with SWFH Supervisor UI!`)
      }
    } else this.setServerCompatibilityWithUIStatus(false, "SWFH Server is not compatible with SWFH Supervisor UI!", `Unable to retrieve configurations from server`);
  }

  setServerCompatibilityWithUIStatus = (isCompatible: boolean, displayMessage: string, logMessage: string): void => {
    this.isServerCompatibleWithUI = isCompatible;

    if (isCompatible === false) {
      log.error(logMessage);
      this.logUploader.error("checkServerCompatibilityWithUI", logMessage, null);
    }
    else {
      log.info(logMessage);
      this.logUploader.info("checkServerCompatibilityWithUI", logMessage);
    }

    this.message = displayMessage;
  }

  checkUICompatibilityWithServer = async (): Promise<void> => {
    const response: string | null = await this.appConfig.GetServerVersion();

    if (response == null || response === "") {
      this.isUICompatibleWithServer = false;
      log.error(`Unable to retrieve server version`);
      this.logUploader.error("checkUICompatibilityWithServer", "Unable to retrieve server version", null);
    }
    else {
      const minReqServerVersion: string = packageInfo.minimumRequiredServerVersion;

      if (minReqServerVersion === "*") {
        log.info(`SWFH Supervisor UI is compatible with SWFH Server`);
        this.isUICompatibleWithServer = true;
      }
      else {
        const firstLetterFromCurrentVersion: string = Array.from(response)[0];
        const firstDigitFromCurrentVersion: number = Number(firstLetterFromCurrentVersion);

        log.info(`Current version of SWFH Server is ${response} and minimum required version is ${minReqServerVersion}`);

        if (firstDigitFromCurrentVersion <= 3) {
          this.isUICompatibleWithServer = false;
          log.error(`SWFH Supervisor UI is not compatible with SWFH Server`);
          this.logUploader.error("checkUICompatibilityWithServer", `SWFH Server Version (${response}) is not >= the minimum required server version (${minReqServerVersion})`, null);
        }
        else {
          const isCurrentVersionGTEMinVersion: boolean = semverGte(response, minReqServerVersion);

          if (isCurrentVersionGTEMinVersion === true) {
            log.info(`SWFH Supervisor UI is compatible with SWFH Server`);
            this.isUICompatibleWithServer = true;
          }
          else {
            this.isUICompatibleWithServer = false;
            log.error(`SWFH Supervisor UI is not compatible with SWFH Server`);
            this.logUploader.error("checkUICompatibilityWithServer", `SWFH Server Version (${response}) is not >= the minimum required server version (${minReqServerVersion})`, null);
          }
        }
      }
    }
  }

  checkNetworkSpeed = async (): Promise<void> => {
    const timeStart: number = performance.now();
    const response: boolean = await this.appConfig.getPingResponse();
    const timeEnd: number = performance.now();
    const totalTime: number = timeEnd - timeStart;

    this.networkSpeedChecked = response;
    log.info(`5. Time Taken By Server: ${totalTime} ms`);
  }

  checkCameraAccess = async (): Promise<void> => {
    try {
      const status: PermissionStatus = await navigator.permissions.query({ name: "camera" });

      if (status.state === "granted") {
        await SetCameraStreamInfo();
        if (this.appConfig.settings.defaults.FaceLoginEnabled == false)
          CloseCameraStream();
        const deviceInfo: MediaDeviceInfo | null = GetCameraDeviceInfo();
        this.summaryData.Camera = deviceInfo?.deviceId ?? "";
        this.cameraAccessChecked = true;
        log.info(`6. Camera Access found ${deviceInfo?.label}`);
        this.logUploader.info("checkCameraAccess", "Camera Access found");
      }
      else if (status.state === "prompt") {
        await TriggerStreamForPermission();
        await this.checkCameraAccess();
        this.checkPrerequisites();
      }
      else this.cameraAccessChecked = false;
    }
    catch (error: any) {
      this.cameraAccessChecked = false;
      log.error(`6. Camera Access not found`, error);
    }
  }

  private timerSubscribe = (): void => {
    if (this.idleTimer === false) {
      return;
    }
    else if (this._idleService.allowedIdleTime == null || this._idleService.idleWarningTime == null) {
      log.warn("Idle Service not initialized yet, retrying timerSubscribe in 50ms");
      setTimeout(() => this.timerSubscribe(), 50);
      return;
    }

    if (this.idleTimerStateSub != null && this.idleTimerStateSub.closed === false) {
      log.debug("Idle timer already subscribed, not doing anything");
      return;
    }

    log.debug(`Subscribing to idle state changes allowed=${this._idleService.allowedIdleTime}s and warning=${this._idleService.idleWarningTime}s`);
    this.idleTimerStateSub = this._idleService.idleStateChanged().subscribe((state: IdleWarningStates) => {
      log.debug(`Idle state triggered: ${state}`)
      if (state === IdleWarningStates.SecondaryTimerExpired) {
        if (this.idleTimerStateSub != null) {
          this.idleTimerStateSub.unsubscribe();
          this.idleTimerStateSub = null;
        }

        if (this.idleTimerStoppedSub != null) {
          this.idleTimerStoppedSub.unsubscribe();
          this.idleTimerStoppedSub = null;
        }

        try {
          this._idleService.stopTimer();
        } catch (error) {

        }

        this.idleTimer = false;
        log.warn(`User Session Expired & Logged out`);
        this.logUploader.warn("timerSubscribe", "User Session Expired & Logged out ");
        this.logout();
      }
    }, error => {
      log.error("An error occurred in the idle state timer", error);
    });

    this.idleTimerStoppedSub = this._idleService.timerStopped().subscribe(val => {
      log.debug(`Idle Timer stopped: ${val}`)
    });

    setTimeout(() => {
      try {
        this._idleService.resetTimer();
        log.debug("Idle timer reset after login");
      } catch (error) {
        log.error("Error in starting idle timer after login", error);
      }
    }, 50);
  }

  handleSuperAdminApproval = (data: any): void => {
    const payload: IViolationWorkflowRequestPayload = {
      EventName: "VIOLATIONWORKFLOW",
      AgentLanId: this.trsService.supervisorId.toUpperCase(), // "SupervisorLanID";
      EventId: data.eventId,
      ViolationId: data.violationId,
      AgentId: data.agentId,
      StatusCode: data.statusCode, // wokrflow status code
      ApproverComments: data.comments,
      RepliedBy: this.trsService.supervisorId.toUpperCase(),
      RepliedDateTime: getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.SendInUTC),
      SentBy: this.trsService.supervisorId.toUpperCase(),
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSUTILITIES", "", payload, this.trsService)));

    payload.EventName = ""
    payload.ActionName = "VIOLATIONWORKFLOW";
    this.ws.sendMessage(JSON.stringify(generateMessage("TMAC", "", payload, this.trsService)));
  }

  sendDisagreeRequestToServer = (response: any): void => {
    const payload: IDisagreeViolationRequestPayload = {
      EventName: "DISAGREEVIOLATION",
      ActionName: "DISAGREEVIOLATION",
      AgentLanId: this.trsService.supervisorId.toUpperCase(), // "SupervisorLanID";
      AgentId: response.RequestArgs.AgentId,
      EventId: response.RequestArgs.EventId,
      ViolationId: response.RequestArgs.ViolationId,
      ReviewStatus: response.RequestArgs.ReviewStatus, // wokrflow status code
      RejectionComment: response.RequestArgs.RejectionComment,
      RejectedBy: this.trsService.supervisorId.toUpperCase(),
      RejectedDateTime: getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.SendInUTC),
      BoundingBoxes: response.RequestArgs.BoundingBoxes == null ? "" : response.RequestArgs.BoundingBoxes,
      RejectionLabel: response.RequestArgs.RejectionLabel,
    };

    this.ws.sendMessage(JSON.stringify(generateMessage("TRSUTILITIES", "", payload, this.trsService)));
    this.ws.sendMessage(JSON.stringify(generateMessage("TMAC", "", payload, this.trsService)));
  }

  clientLogUpload = (response: any): void => {
    const payload: IGenericRequestPayload = {
      EventName: "CLIENTLOGUPLOAD",
      AgentLanId: response.AgentLanId, // Agent for whom logs need to be uploaded to server
    };

    this.ws.sendMessage(JSON.stringify(generateMessage("TRS", "TRS", payload, this.trsService)));
  }

  clearSessionOverideInterval() {
    clearInterval(this.sessionTakeOverIntervalId);
    this.sessionTakeOverIntervalId = 0;
  }

  public async handleResponseMessages(responseData: any) {
    try {
      if (responseData == null) {
        return;
      }
      if (responseData === "HEARTBEAT" || responseData === "PING") {
        this.ws.handleHeartbeatResponse();
        return;
      }
      let response = JSON.parse(responseData);
      if (response.ResponseToCommand) {
        this.logUploader.info("handleResponseMessages", `RESPONSE ${JSON.stringify(responseData)}`);
        if (response.ResponseBody) {
          if (response.ResponseBody.JwtToken) {
            this.trsService.JwtAuthenticationToken = response.ResponseBody.JwtToken;
            this.trsService.JwtRefreshToken = response.ResponseBody.JwtToken;
          }
        }
        switch (response.ResponseToCommand) {
          case "REGISTER":
            log.info(`RESPONSE ${response.ResponseToCommand}`, response.ResponseBody);
            this.hideLoading = false;
            if (this.trsService.supervisorId) {
              this.trsService.supervisorId = this.trsService.supervisorId.toUpperCase();

              log.debug("[handleResponseMessages: REGISTER command] Clearing localstorage");
              window.localStorage.clear();

              window.localStorage.setItem('AgentLanId', this.trsService.supervisorId.toUpperCase());
              window.localStorage.setItem("TraceId", this.ws.traceId);

              window.name = JSON.stringify({
                'supervisorId': this.trsService.supervisorId.toUpperCase(),
                'traceId': this.ws.traceId
              });
            }

            this.ws.onRegisterResponse();
            if (this.router.url !== '/home') {
              this.router.navigate(['/home']);
            }

            this.trsService.UploadMilestoneAction({
              SummaryId: this.ws.traceId,
              Action: "Request SUPERVISORINIT",
              OtherData: "NA",
              ActionDateTime: getUTCDateObj(),
            });

            log.debug(`REQUEST SUPERVISORINIT`);
            this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", {
              EventName: "SUPERVISORINIT",
              AgentLanId: this.trsService.supervisorId,
              AgentTeamId: this.trsService.TeamId,
              DisplayInSupervisorUI: false,
              RefreshAgentFeatures: true,
              IsConnected: true,
            }, this.trsService)));
            break;
          case "TetherfiAuthResponse":
            log.info(`RESPONSE ${response.ResponseToCommand}`, responseData);
            this.hideLoading = false;
            if (this.trsService.supervisorId) {
              this.trsService.supervisorId = this.trsService.supervisorId.toUpperCase();
              window.name = JSON.stringify({
                supervisorId: this.trsService.supervisorId,
                traceId: this.ws.getTraceId(),
              });
            }

            this.trsService.JwtAuthenticationToken = response.ResponseBody.JWTToken;
            this.trsService.JwtRefreshToken = response.ResponseBody.RefreshToken;

            this.trsService.UploadMilestoneAction({
              SummaryId: this.ws.traceId,
              Action: "Request SUPERVISORINIT",
              OtherData: "NA",
              ActionDateTime: getUTCDateObj(),
            });

            log.debug(`REQUEST SUPERVISORINIT`);
            this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", {
              EventName: "SUPERVISORINIT",
              AgentLanId: this.trsService.supervisorId,
              AgentTeamId: this.trsService.TeamId,
              DisplayInSupervisorUI: false,
              RefreshAgentFeatures: true,
              IsConnected: true,
            }, this.trsService)));
            break;
          case "LICENSEEXPIRY":
            log.info(`RESPONSE ${response.ResponseToCommand}`, response.ResponseBody);
            this.toastService.warning(this.licenseExpiryErrorLabel);
            this.logout();
            break;
          case "SESSIONTAKEOVER":
            log.info(`RESPONSE ${response.ResponseToCommand}`, responseData);
            this.handleSessionTakeover();
            break;
          case "SESSIONTAKEOVERRESPONSE":
            log.info(`RESPONSE ${response.ResponseToCommand}`, responseData);
            this.sendEvent(response.ResponseToCommand, response.ResponseBody);
            //received by another supervisor who tries to login with same id as already logged in user
            this.handleSessionTakeOverResponse(response.ResponseToCommand);
            break;
          case "PINAGENT":
          case "ARCHIVEAGENT":
            log.info(`RESPONSE ${response.ResponseToCommand}`, responseData);
            this.sendEvent(response.ResponseToCommand, response.ResponseBody);
            break;
          case "GETAGENTSESSIONLIST":
            log.info(`RESPONSE ${response.ResponseToCommand}`, response.ResponseBody);
            this.showHeaderFooter = true;
            this.sendEvent(response.ResponseToCommand, response.ResponseBody);
            break;
          case "LOADNEXTVIOLATIONS":
          case "TEAMCHECKIN":
          case "GETUNIQUEVIOLATIONNAMES":
            this.sendEvent(response.ResponseToCommand, response.ResponseBody);
            break;
          case "SUPERVISORINIT":
            log.info(`RESPONSE ${response.ResponseToCommand}`, response.ResponseBody);
            const supervisorInfo: ISupervisorInit = response.ResponseBody;
            this.sendEvent(response.ResponseToCommand, supervisorInfo);
            if (supervisorInfo != null) {
              log.info(`a: this.trsService.supervisorId ${this.trsService.supervisorId}`);
              this.logUploader.info("handleResponseMessages", `this.trsService.supervisorId ${this.trsService.supervisorId}`);

              if (supervisorInfo.AgentProfile != null && supervisorInfo.AgentProfile === "S") {
                if (supervisorInfo.AgentFeatures != null) {
                  this.trsService.UploadMilestoneAction({
                    SummaryId: this.ws.traceId,
                    Action: "Response received SUPERVISORINIT",
                    OtherData: "NA",
                    ActionDateTime: getUTCDateObj(),
                  });

                  this.trsService.AgentTime = supervisorInfo.AgentTime;
                  this.trsService.Hierarchy = supervisorInfo.Hierarchy;
                  this.trsService.TeamId = supervisorInfo.TeamId;

                  if (this.trsService.isLoggedIn === false)
                    this.auditService.AuditSupervisorUsage(6);
                  this.trsService.isLoggedIn = true;

                  this.GetSupervisorPreferences();
                  this.GetSessionList();

                  if (supervisorInfo.AgentFeatures.length > 0) {
                    if (supervisorInfo.AgentFeatures[0].AgentLanId === this.trsService.supervisorId) {
                      this.trsService.supervisorAvayaLoginId = supervisorInfo.AgentFeatures[0].AvayaLoginId;

                      if (supervisorInfo.AgentFeatures[0].AgentProfilePic != null && supervisorInfo.AgentFeatures[0].AgentProfilePic !== "")
                        this.trsService.supervisorProfilePicture = supervisorInfo.AgentFeatures[0].AgentProfilePic;
                      else this.trsService.supervisorProfilePicture = "assets/images/profile-image.png";
                    }
                  }

                  if (this.trsService.supervisorAvayaLoginId == null || this.trsService.supervisorAvayaLoginId === "")
                    this.trsService.supervisorAvayaLoginId = supervisorInfo.AvayaLoginId;

                  if (supervisorInfo.TeamsInHierarchy != null)
                    this.trsService.supervisorOrgHierarchy = supervisorInfo.TeamsInHierarchy;

                  this.trsService.clientName = this.appConfig.GetClientName();

                  setNotificationSound();
                  if (this.idleTimer === false)
                    this.idleTimer = true;
                  this.timerSubscribe();
                }
                else {
                  log.error("Supervisor Agent Features are not present");
                  this.onLoginFailed();
                }
              }
              else {
                log.error(`Supervisor Profile (${supervisorInfo.AgentProfile}) is not supervisor`);
                this.onLoginFailed();
              }
            }
            break;
          case "AUDITACKNOWLEGED":
            if (response.ResponseBody) {
              this.sendEvent(response.ResponseBody.ActionName, response.ResponseBody);
            }
            break;
          case "REFRESHMEDIAURL":
            if (response.ResponseBody)
              this.sendEvent("SIGNEDMEDIAURL", response.ResponseBody);
            break;
          case "REFRESHPROFILEPIC":
            if (response.ResponseBody) {
              this.agentListInfoService.UpdateProfilePicture(response.ResponseBody.AgentLanId, response.ResponseBody.ProfilePicUrl);
              this.sendEvent("REFRESHEDPROFILEPIC_RESPONSE", response.ResponseBody.AgentLanId);
            }
            break;
          case "GETAGENTFEATURES":
            if (this.appConfig.settings.defaults.FaceLoginEnabled === true) {
              if (response.ResponseBody != null) {
                const supervisorInfo: ISupervisorInit = response.ResponseBody;

                if (supervisorInfo.AgentProfile != null && supervisorInfo.AgentProfile === "S") {
                  if (supervisorInfo.AgentFeatures.length > 0) {
                    const confidenceFeatureName: string = "TRS_FACE_AUTH_CONFIDENCE";
                    let isFeatureFound: boolean = false;
                    let confidenceValue: any = 0;

                    if (supervisorInfo.AgentIndividualFeatures != null) {
                      if (supervisorInfo.AgentIndividualFeatures != null) {
                        for (const featureInfo of supervisorInfo.AgentIndividualFeatures) {
                          if (featureInfo.Feature === confidenceFeatureName) {
                            if (featureInfo.Enable != null && featureInfo.Enable !== false) {
                              isFeatureFound = true;
                              confidenceValue = featureInfo.FeatureValue;
                            }
                            break;
                          }
                        }
                      }
                    }

                    if (isFeatureFound === false) {
                      if (supervisorInfo.AgentFeatures != null) {
                        for (const featureInfo of supervisorInfo.AgentFeatures) {
                          if (featureInfo.Feature === confidenceFeatureName) {
                            if (featureInfo.Enable != null && featureInfo.Enable !== false) {
                              isFeatureFound = true;
                              confidenceValue = featureInfo.FeatureValue;
                            }
                            break;
                          }
                        };
                      }
                    }

                    if (isFeatureFound === true) {
                      if (confidenceValue == null || confidenceValue === "" || Number.isNaN(confidenceValue) === true) {
                        this.sendEvent("FACE_AUTH_LOGIN_FAILURE", {});
                        this.toastService.error(`${this.loginFailedErrorLabel}: ${this.supervisorValidationMessage1}: ${confidenceFeatureName}`);
                      }
                      else {
                        if (this._faceLoginService.setFaceAuthRequestConfidence(Number(confidenceValue)) === true) {
                          if (await this._faceLoginService.AuthenticateUser() === true) {
                            this.sendEvent("FACE_AUTH_LOGIN_SUCCESS", {});
                          }
                          else this.sendEvent("FACE_AUTH_LOGIN_FAILURE", {});
                        }
                        else {
                          this.sendEvent("FACE_AUTH_LOGIN_FAILURE", {});
                          this.toastService.error(`${this.loginFailedErrorLabel}: ${this.supervisorValidationMessage1}: ${confidenceFeatureName}`);
                        }
                      }
                    }
                    else {
                      this.sendEvent("FACE_AUTH_LOGIN_FAILURE", {});
                      this.toastService.error(`${this.loginFailedErrorLabel}: ${this.supervisorValidationMessage1}: ${confidenceFeatureName}`);
                    }
                  }
                  else {
                    this.sendEvent("FACE_AUTH_LOGIN_FAILURE", {});
                    this.toastService.error(`${this.loginFailedErrorLabel}: ${this.supervisorValidationMessage2}`);
                  }
                }
                else {
                  log.error(`Supervisor Profile (${supervisorInfo.AgentProfile}) is not supervisor`);
                  this.sendEvent("FACE_AUTH_LOGIN_FAILURE", {});
                  this.toastService.error(`${this.loginFailedErrorLabel}`);
                }
              }
              else {
                this.sendEvent("FACE_AUTH_LOGIN_FAILURE", {});
                this.toastService.error(`${this.loginFailedErrorLabel}`);
              }
            }
            break;
          case "GETSUPERVISORPREFERENCES":
            const preferences: ISupervisorPreferencePayload = response.ResponseBody;
            this.supervisorService.UpdatePreferences(preferences.Preferences);
            break;
          default:
            break;
        }
      }
      else if (response.RequestArgs) {
        if (response.Command == "WEBRTC") {
          switch (response.RequestArgs.messageType) {
            case "BARGEININITACK":
            case "BARGEINACK":
            case "TRICKLEICEACK":
            case "ENDBARGEINACK":
              log.debug(`Received WebRTC ACK Message: ${response.RequestArgs.messageType}`);
              break;
            case "SCREENGRABDATA":
            case "SCREENGRABDENIED":
            case "ANSWER":
            case 'TRICKLEICE':
            case "OFFERDECLINED":
            // case "BARGEINDECLINED":
            case "BARGEININITRESPONSE":
            case "BARGEININITDECLINED":
            case "BARGEINLIMITREACHED":
            case "ERROR":

            case "BARGEIN":
            case "BARGEININIT":
            case "BARGEININPROGRESS":
            case "ENDBARGEIN":
              log.debug(`WebRTC Message received: ${response.RequestArgs.messageType}`);
              this.sendEvent(response.RequestArgs.messageType, response.RequestArgs);
              break;
            default:
              log.debug(`Unhandled WebRTC Message received`, response.RequestArgs);
              break;
          }
        }
        else {
          log.debug(`ActionName`, response.RequestArgs.ActionName);
          switch (response.RequestArgs.ActionName) {
            case "VIOLATIONWORKFLOW":
              const data = response.RequestArgs;
              if (this.trsService.events[data.AgentId.toUpperCase()] == null) {
                return;
              }

              const index: number = this.trsService.events[data.AgentId.toUpperCase()].findIndex((violation: { ViolationId: any; }) => violation.ViolationId == data.ViolationId);

              if (index >= 0) {
                this.trsService.events[data.AgentId.toUpperCase()][index].Show = true;
                this.trsService.events[data.AgentId.toUpperCase()][index].StatusCode = data.StatusCode;
                this.trsService.events[data.AgentId.toUpperCase()][index].ApproverComments = data.ApproverComments;
                this.trsService.events[data.AgentId.toUpperCase()][index].AgentLanId = data.AgentId;
                this.trsService.events[data.AgentId.toUpperCase()][index].SentDateTime = data.SentDateTime;
              }

              if (data.StatusCode == 0) {
                if (data.SentBy !== this.trsService.supervisorId)
                  this.toastService.success(this.reviewEscalatedViolationLabel);
                else
                  this.toastService.success(this.sentEscalatedViolationLabel);
              }
              else {
                //Checking if the logged in supervisor is the one who escalated the violation
                if (data.RepliedBy !== this.trsService.supervisorId && data.SentBy === this.trsService.supervisorId) {
                  if (data.StatusCode === 2)
                    this.toastService.error(this.escalatedViolationRejectedLabel);
                  else
                    this.toastService.success(this.escalatedViolationApprovedLabel);
                }
              }
              break;
            case "PEEPCOMPLETE":
              const violationId: string = this.createGuid().toString();
              response.RequestArgs.ViolationId = violationId;
              this.sendEvent(response.RequestArgs.ActionName, response.RequestArgs);
              this.DBOperationToAggregator(response.RequestArgs.AgentLanId, "Peep response received",
                response.RequestArgs.CamPicURL, response.RequestArgs.ScreenShotURL, response.RequestArgs.ScreenVideoURL, response.RequestArgs.CamVideoURL, violationId,
                response.RequestArgs.Latitude, response.RequestArgs.Longitude);
              break;
            case "CHATMESSAGERECEIVED":
            case "PEEPDENIED":
            case "TRSLOGGEDIN":
            case "TRSCLIENTDISCONNECTED":
            case "TRSCLIENTCONNECTED":
            case "VIOLATION":
            case "CLIENTLOGUPLOADED":
            case "STEALTHMODE":
            case "AUXCODECHANGE":
            case "BLOCKAPPROVED":
            case "SCREENBLOCKED":
            case "UNBLOCKSCREEN":
            case "UNBLOCKAPPROVED":
            case "SCREENBLOCKAPPROVED":
            case "PROFANITYWORDSDETECTED":
            case "NEGATIVESENTIMENTDETECTED":
            case "PROFANITYAUDIO":
              log.debug(`response.ResponseToCommand:  ${response.ResponseToCommand}`);
              this.sendEvent(response.RequestArgs.ActionName, response.RequestArgs);
              break;
            case "DISAGREEVIOLATION":
              log.debug(`response.ResponseToCommand:  ${response.ResponseToCommand}`);
              this.toastService.info(this.violationDisagreedLabel);
              this.sendEvent(response.RequestArgs.ActionName, response.RequestArgs);
              break;
            default:
              log.debug(`Unknown Command ${response.RequestArgs.ActionName}`);
              break;
          }
        }
      }
    }
    catch (ex) {
      log.error(`Exception in onMessage`, ex);
    }
  }

  handleSessionTakeOverResponse(commandName: string) {
    let msg: string = "";

    if (this.appConfig.settings.Allowed.includes("SESSIONTAKEOVER"))
      msg = `${this.sessionTakeOverAllowedLabel} ${this.sessionOverideTime}s`;
    else msg = this.sessionTakeOverNotAllowedLabel;

    this.toastService.warning(msg);
    log.info(msg);
    this.logUploader.info("handleSessionTakeOverResponse", msg);

    setTimeout(() => this.logout(), 3000);
  }

  handleSessionTakeover = (): void => {
    if (!this.trsService.supervisorId)
      return;

    if (this.isLogoutTimerRunning === false) {
      this.isLogoutTimerRunning = true;
      this.timeleft = this.sessionOverideTime;
      this.showLoginPopUp = true;
      this.toastService.success(`${this.sessionOvertakenLabel} ${this.timeleft}s`, this.sessionTakeoverLabel, {
        timeOut: this.timeleft,
      });

      this.sessionOvertakeTimer = setInterval(() => {
        this.timeleft--;
        if (this.timeleft <= 0) {
          clearInterval(this.sessionOvertakeTimer);
          this.showLoginPopUp = false;
          this.message = '';
          this.isLogoutTimerRunning = false;
          this.logout();
        }
      }, 1000);
    }
  }

  sessionOverTakeApprovalStatus = (allow: boolean): void => {
    clearInterval(this.sessionOvertakeTimer);
    this.showLoginPopUp = false;
    this.message = '';
    this.isLogoutTimerRunning = false;

    if (allow === true)
      this.logout();
  }

  handleLogout = (reloadPage: boolean = true, navigationURL: string = "", redirectToInternalLogoutPage: boolean): void => {
    try {
      {
        log.debug(`handleLogout`);

        this.teamCheckInService.stopTeamCheckInMonitor();
        this.eventFilterService.stopEventFilterMonitor();

        if (this.webrtcInfoService.isCallInProgress() === true) {
          const callingAgentLanId: string = this.webrtcInfoService.getCallingAgentLanId();
          const payload: IWebRTCMessageRequestPayload = {
            MessageType: "ENDBARGEIN",
            Body: '',
            MediaId: 'Video',
            Index: 0,
            From: this.trsService.supervisorId,
            To: callingAgentLanId,
            FromId: `SUPERVISOR_${this.trsService.supervisorId.toUpperCase()}`,
            ToId: callingAgentLanId,
            Candidate: '',
            ScreenIds: this.webrtcInfoService.getSelectedScreensForScreenShare(),
            ClientName: this.trsService.clientName ?? "",
            CreatedDateTime: getUTCDateObj(),
            Message: this.webrtcInfoService.generateEndCode("supervisor-logout"),
            UniqueId: this.webrtcInfoService.getUniqueIdForSession(),
            AgentCurrentAuxCode: this.agentListInfoService.GetAgentInfo(callingAgentLanId)?.AgentCurrentAuxCode ?? 'na',
          };
          const requestMessage: ISWFHMessagePayload = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);

          log.info(`SEND ENDBARGEIN`, requestMessage);
          this.sendScreenGlanceMessage(requestMessage);
          this.auditService.AuditScreenGlance('end', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason("supervisor-logout"));
        }

        const d: Date = new Date();
        this.message = '';

        this.trsService.TeamId = 0;
        this.trsService.isLoggedIn = false;
        this._faceLoginService.isFaceAuthSuccess = false;
        this.trsService.supervisorId = '';
        this.showHeaderFooter = false;
        this.WSConnected = false;
        this.showConnectionModal = false;
        this.trsService.selectedAgentId = '';

        if (this.networkOfflineInterval != null) {
          clearInterval(this.networkOfflineInterval);
          this.networkOfflineStartTime = 0;
        }
        this.ws.closeWebSocket();

        log.debug("[handleLogout] Clearing localstorage");
        window.localStorage.removeItem('AgentLanId');
        window.localStorage.clear();
        log.debug("[handleLogout] Items after clearing localstorage", window.localStorage.length);
        window.name = '';

        closeBroadcastChannel();

        this.agentListInfoService.ClearAgentList();

        d.setTime(d.getTime());
        document.cookie = `identity=;domain=${this.appConfig.settings.SSO.sSSODomain};path=/;expires=${d.toUTCString()}`;

        if (this.appConfig.settings.SSO.Enabled === true) {
          //if SSO Login enabled dont change path
        }
        else if (this.appConfig.settings.IAM.Enabled == true) {

        }
        else this.router.navigate([""]);

        if (reloadPage === true) {
          setTimeout(() => {
            if (navigationURL == null || navigationURL === "")
              location.reload();
            else {
              log.info(`Replacing Window Location: ${navigationURL}`);
              location.replace(navigationURL);
            }
          }, 2000);
        }
        else if (redirectToInternalLogoutPage == true)
          this.router.navigate(['/logout']);
      }
    } catch (ex) {
      log.error(`Exception in onLogout`, ex);
    }
  }

  updateArchiveStatusToServer = (response: any): void => {
    log.debug(`Archived Agent: ${response.AgentLanId}`);
    const payload: IArchiveRequestPayload = {
      EventName: "ARCHIVEAGENT",
      AgentLanId: response.AgentLanId,
      AgentTeamId: this.trsService.TeamId,
      AgentId: response.AgentLanId, //Agent Id of Agent who is to be archived
      IsArchived: response.IsArchived, // true/false based on Archive/unarchive
    };

    log.debug(`Sending updated archived status ${response.IsArchived} for agent ${response.AgentLanId} `);
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
  }

  updatePinStatusToServer = (response: any): void => {
    const payload: IPinRequestPayload = {
      EventName: "PINAGENT",
      AgentLanId: this.trsService.supervisorId,
      AgentTeamId: this.trsService.TeamId,
      AgentId: response.AgentLanId,
      IsPinned: response.IsPinned,
    };

    log.debug(`Sending updated pinned status ${response.IsPinned} for agent ${response.AgentLanId} `);
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
  }

  sendChatMessage = (response: ISWFHMessagePayload): void => this.ws.sendMessage(JSON.stringify(response))

  sendForApproval = (payload: IViolationWorkflowRequestPayload): void => {
    payload.SentDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.SendInUTC);
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSUTILITIES", "", payload, this.trsService)));

    payload.ActionName = "VIOLATIONWORKFLOW";
    payload.EventName = "";

    this.ws.sendMessage(JSON.stringify(generateMessage("TMAC", "", payload, this.trsService)));
  }

  refresh() {
    this.hideLoading = false;
    this.showHeaderFooter = true;
    setTimeout(() => {
      this.GetSessionList();
    }, 5000);
  }

  loadNextViolations = (data: any): void => {
    log.debug(`Sending load next violation request for agent ${data.agentLanId}`)

    const payload: ILoadViolationRequestPayload = {
      EventName: "LOADNEXTVIOLATIONS",
      AgentLanId: data.agentLanId,
      RecordCount: data.recordCount, // Current Number of Violations Shown on Screen
      PageSize: data.pageSize //Number of pervious vilations to be fetched
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
  }

  createGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  sendEvent(eventName: any, responseData: any) {
    let data = {
      "eventName": eventName,
      "data": responseData,
      "time": new Date()
    };
    this.trsService.evtdata.next(data);
  }

  onLoginFailed = (): void => {
    this.trsService.UploadMilestoneStatus({
      SummaryId: this.ws.traceId,
      Status: "Login Failed",
      Reason: "Invalid Id",
      StatusDateTime: getUTCDateObj(),
    });

    this.showLoginErrorPopup();
  }

  showLoginErrorPopup() {
    try {
      log.info(`Error in login`)
      this.showHeaderFooter = false;
      this.toastService.warning(`${this.loginFailedErrorLabel}: ${this.trsService.supervisorId}`);

      setTimeout(() => this.logout(), 3000);
    } catch (ex) {
      log.error(`Exception in showLoginErrorPopup`, ex);
    }
  }

  GetSessionList = (): void => {
    log.debug(`REQUEST GETAGENTSESSIONLIST`);
    const payload: IAgentSessionListRequestPayload = {
      EventName: "GETAGENTSESSIONLIST",
      AgentLanId: this.trsService.supervisorId,
      AgentTeamId: this.trsService.TeamId,
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
  }

  updateStealthModeToServer = (data: any): void => {
    log.debug(`sendStealthModeResponse`);
    const msg: string = data.AllowStatus ? "StealthMode Approved" : "StealthMode Denied";

    this.DBOperationToAggregator(data.AgentLanId, msg, "NA", "NA", "NA", "NA", null, null, null);

    const payload: IStealthModeResponsePayload = {
      EventName: "STEALTHMODE",
      AgentLanId: data.AgentLanId,
      EventData: "{ \"enabled\": " + data.AllowStatus + "}",
      Sender: this.trsService.supervisorId,
    };

    this.ws.sendMessage(JSON.stringify(generateMessage("TRS", "TRS", payload, this.trsService)));
  }

  DBOperationToAggregator = (agentLanId: string, command: string, camPic: string, screenshot: string, screenVideo: string, camVideo: string | undefined, violationId: null | string = null, latitude: number | null, longitude: number | null): void => {
    const appVersion: string = packageInfo.version;
    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(agentLanId);

    const payload1: InsertViolationToDbRequestPayload = {
      AgentId: agentLanId,
      ViolationName: command,
      AgentStatus: agentInfo != null && agentInfo.AgentCurrentAuxCode != null && agentInfo.AgentCurrentAuxCode !== "" ? agentInfo.AgentCurrentAuxCode : "NA",
      Threshold: "0",
      ActionSummary: "insertToDB",
      CamPicURL: camPic,
      ScreenShotURL: screenshot,
      ScreenVideoURL: screenVideo,
      CamVideoURL: camVideo,
      QrvideoUrl: "",
      ViolationId: violationId == null || violationId === "" ? this.createGuid().toString() : violationId,
      ViolationDateTime: getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.SendInUTC),
      EventTypeId: "5",
      BuildVersion: appVersion,
      ModelVersion: null,
      BoundingBoxes: null,
      Latitude: latitude != null ? latitude : 0.0,
      Longitude: longitude != null ? longitude : 0.0,
    };
    const payload2: InsertViolationToDbRequestPayload2 = {
      ViolationDetails: payload1,
    };

    this.ws.sendMessage(JSON.stringify(generateMessage("DBOPERATIONS", "TRS", payload1, this.trsService)));
    this.ws.sendMessage(JSON.stringify(generateMessage("TMAC", "TRS", payload2, this.trsService)));
  }

  blockAgentScreen = (agentLandId: string): void => {
    const payload: IGenericRequestPayload = {
      EventName: "SCREENBLOCK",
      AgentLanId: agentLandId, //Agent whose screen needs to be blocked
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRS", "TRS", payload, this.trsService)));
  }

  unblockAgentScreen = (agentLandId: string): void => {
    const payload: IUnblockScreenRequestPayload = {
      EventName: "UNBLOCKSCREEN",
      AgentLanId: agentLandId, // Agent for whom screen needs to be unblocked
      BlackOutToken: "838437",
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRS", "TRS", payload, this.trsService)));
  }

  screenGrabRequest = (agentLanId: string): void => {
    const payload: IScreenGrabRequestPayload = {
      EventName: "SCREENGRAB",
      AgentLanId: agentLanId,
      BuildVersion: packageInfo.version,
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRS", "TRS", payload, this.trsService)));
  }

  sendScreenGlanceMessage = (data: ISWFHMessagePayload): void => this.ws.sendMessage(JSON.stringify(data));

  sendScreenGlanceHeartBeat = (data: IWebRTCHeartbeatPayload): void => this.ws.sendMessage(JSON.stringify(data));

  peepRequest = (agentLanId: string): void => {
    const payload: IGenericRequestPayload = {
      EventName: "PEEP",
      AgentLanId: agentLanId,
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRS", "TRS", payload, this.trsService)));
    this.DBOperationToAggregator(agentLanId, "Peep request sent", "NA", "NA", "NA", undefined, null, null, null);
  }

  doBeforeUnload() {
    //window.localStorage['myUnloadEventFlag'] contains the current time 
    // which is used to check if the page was refreshed or browser closed
    log.debug(`doBeforeUnload`);

    if (this.trsService.isLoggedIn === true && this.webrtcInfoService.isCallInProgress() === true) {
      const callingAgentLanId: string = this.webrtcInfoService.getCallingAgentLanId();
      const payload: IWebRTCMessageRequestPayload = {
        MessageType: "ENDBARGEIN",
        Body: '',
        MediaId: 'Video',
        Index: 0,
        From: this.trsService.supervisorId,
        To: callingAgentLanId,
        FromId: `SUPERVISOR_${this.trsService.supervisorId.toUpperCase()}`,
        ToId: callingAgentLanId,
        Candidate: '',
        ScreenIds: this.webrtcInfoService.getSelectedScreensForScreenShare(),
        ClientName: this.trsService.clientName ?? "",
        CreatedDateTime: getUTCDateObj(),
        Message: this.webrtcInfoService.generateEndCode("supervisor-tab-close"),
        UniqueId: this.webrtcInfoService.getUniqueIdForSession(),
        AgentCurrentAuxCode: this.agentListInfoService.GetAgentInfo(callingAgentLanId)?.AgentCurrentAuxCode ?? 'na',
      };
      const requestMessage: ISWFHMessagePayload = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);

      log.info(`SEND ENDBARGEIN`, requestMessage);
      this.sendScreenGlanceMessage(requestMessage);
      this.auditService.AuditScreenGlance('end', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason("supervisor-tab-close"));
      this.sendEvent("BROWSER_TAB_CLOSE", {});
    }

    if (window.name) {
      window.localStorage.removeItem('AgentLanId');
    }
    // flag the page as being unloading
    localStorage['myUnloadEventFlag'] = new Date().getTime();

    if (AppConfig.settings.SSO.Enabled === true && this.out) {
      $.ajax({
        url: AppConfig.settings.SSO.jwtAuthServerUrl + "/LogOut",
        type: "POST",
        headers: { 'IsBrowserClose': 'true' },
        success: function (result: any) {

        },
        error: function (error: any) {

        }
      });
    }
  }

  doOnload() {
    log.debug(`doOnload`);

    var t0 = Number(window.localStorage['myUnloadEventFlag']);
    if (Number.isNaN(t0)) t0 = 0;
    var t1 = new Date().getTime();
    var duration = t1 - t0;

    //Do this just to make sure that the login.ts methods are loaded
    checkIfBroadcastChannelIsOpen();

    const isAnExistingLoginAvailable: boolean = isExistingLoginAvailable(this.ws, this.toastService, this.trsService, this.translationService, true);

    if (isAnExistingLoginAvailable === true) {
      if (this.appConfig.settings.defaults.FaceLoginEnabled === true)
        this._faceLoginService.isFaceAuthSuccess = true;
      return;
    }

    if (AppConfig.settings.SSO.Enabled === true && duration < 10 * 1000) {
      $.ajax({
        url: AppConfig.settings.SSO.jwtAuthServerUrl + "/CancelLogOut",
        success: function (result: any) {
          log.info(`Success`, result);
        },
        error: function (error: any) {
          log.error(`Error`, error);
        }
      });
    }
  }

  doMouseOut() {
    this.out = true;
  }

  doMouseOver() {
    this.out = false;
  }

  checkOfflineConnection = (): void => {
    if (this.trsService.isLoggedIn === true) {
      const currentDate: number = performance.now();
      const diff: number = (currentDate - this.networkOfflineStartTime) / 1000;
      const differenceInSeconds: number = Math.round(diff);

      if (differenceInSeconds > this.maxTimeToWaitAfterNetworkDisconnect) {
        //this means it has been more than 20 seconds since the disconnect happened
        log.info(`Websocket connection has been down since ${differenceInSeconds} seconds`);
        this.handleLogout(true, "", false);
      }
      else {
        log.info(`Websocket connection was down for ${differenceInSeconds} seconds`);

        this.networkOfflineStartTime = 0;

        if (this.WSConnected === true) {
          //lets say there was a network disconnect for 2sec and then socket connected
          // Then we have to update the violations etc.
          log.info(`Websocket reconnected after ${differenceInSeconds} seconds`);

          this.sendEvent("NETWORK_RECONNECT", {});
        }
      }
    }
  }

  logout = (): void => {
    if (this.trsService.iamSessionIntervalCheck != null) {
      clearInterval(this.trsService.iamSessionIntervalCheck);
    }

    this.auditService.AuditSupervisorUsage(7);

    if (this.appConfig.settings.SSO.Enabled === true)
      this.sendEvent("LOGOUT-SSO", {});
    else if (this.appConfig.settings.IAM.Enabled === true)
      this.sendEvent("LOGOUT-IAM", {});
    else this.sendEvent("LOGOUT", {});
  }

  setIAMTokenInterval = (): void => {
    this.trsService.iamSessionIntervalCheck = setInterval(() => {
      const accessToken: string | null = getItemValueFromCookie("access-token-swfh_supervisor");

      if (accessToken == null || accessToken === "") {
        this.toastService.warning(this.iamSessionExpiredLabel);
        this.logout();
      }
    }, 5000);
  }

  refreshMediaURLRequest = (data: any): void => {
    const payload: IRefreshMediaRequestPayload = {
      EventName: "REFRESHMEDIAURL",
      AgentLanId: data.AgentLanId,
      EventId: data.EventId,
      ViolationId: data.ViolationId,
      SentBy: data.supervisorId,
      SubSessionIds: data.SubSessionIds ?? [],
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSUTILITIES", "", payload, this.trsService)));
  }

  refreshProfilePicture = (data: any): void => {
    const payload: IGenericRequestPayload = {
      EventName: "REFRESHPROFILEPIC",
      AgentLanId: data.AgentLanId,
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSUTILITIES", "", payload, this.trsService)));
  }

  sendTeamCheckInRequest = (agentList: string[]): void => {
    log.debug(`Sending Team Checkin request`)

    const payload: ITeamCheckInRequestPayload = {
      EventName: "TEAMCHECKIN",
      AgentLanId: this.trsService.supervisorId,
      AgentList: agentList,
    };

    this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
  }

  sendUniqueViolationsRequest = (): void => {
    log.debug(`Sending Unique Violations request`)

    const payload: IUniqueViolationsRequestPayload = {
      EventName: "GETUNIQUEVIOLATIONNAMES",
      AgentLanId: this.trsService.supervisorId,
    };

    this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
  }

  GetSupervisorPreferences = (): void => {
    log.debug(`Requesting Supervisor Preferences`);
    const payload: ISupervisorPreferenceRequestPayload = {
      EventName: "GETSUPERVISORPREFERENCES",
      SupervisorLanId: this.trsService.supervisorId,
    };
    this.ws.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
  }
}